/// <reference types="@types/google.maps" />
import { Component, computed, effect, input, OnInit } from '@angular/core';
import { LoadingWidget } from '@deck.gl/widgets';
import { MVTLayer } from '@deck.gl/geo-layers';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import * as gMapsApiLoader from '@googlemaps/js-api-loader';
import { environment } from '../../../../../environments/environment';
import { defaultLayerProps } from '../../../../shared/utils/layerProps';

const MONIT_AREA_ID = 'monitoring-areas-layer';
const STATE_LAYER_ID = 'states-layer';
type monitPoint = {};

@Component({
  selector: 'app-results-map',
  imports: [],
  templateUrl: './results-map.component.html',
  styleUrl: './results-map.component.scss',
})
export class ResultsMapComponent implements OnInit {
  gMap: google.maps.Map | null = null;
  public readonly gmapElementId = 'gmap';
  idList = input<number[]>([]);
  monitAreaURL = computed(() => this.getMonitAreaURL(this.idList()));

  constructor() {
    effect(() => {
      this.renderLayers(this.getMonitAreaLayer(this.monitAreaURL()));
    });
  }

  private getMonitAreaURL(idList: number[]) {
    const params = new URLSearchParams({
      idList: JSON.stringify(idList),
    });
    return `${environment.MARTIN_PROTOCOL}://${environment.MARTIN_HOST}/get_monit_results_mvt/{z}/{x}/{y}?${params}`;
  }

  private getMonitAreaLayer = (url: string) =>
    new MVTLayer<monitPoint>({
      ...defaultLayerProps,
      id: MONIT_AREA_ID,
      data: [url],

      pointType: 'icon',
      getIconSize: 24,
      iconSizeUnits: 'pixels',
      getIcon: () => ({
        url: '/map-pin.png',
        x: 0,
        y: 0,
        width: 149,
        height: 200,
        anchorY: 174,
      }),
      iconAlphaCutoff: -1,

      pickable: true,
      autoHighlight: true,
      highlightColor: [255, 255, 255, 128],
    });

  private stateLayer = new MVTLayer<{
    CD_UF: string;
    NM_UF: string;
    SIGLA_UF: string;
    CD_REGIA: string;
    NM_REGIA: string;
    SIGLA_RG: string;
    AREA_KM2: number;
  }>({
    ...defaultLayerProps,
    id: STATE_LAYER_ID,
    data: `${environment.MARTIN_PROTOCOL}://${environment.MARTIN_HOST}/ibge_uf`,
    getLineColor: () => [255, 255, 255, 255], // branco
    getFillColor: () => [0, 0, 0, 0], // transparente
    lineWidthUnits: 'pixels',
    getLineWidth: 2,
    pickable: false,
    autoHighlight: false,
    highlightColor: [255, 255, 255, 128],
  });

  ngOnInit(): void {
    this.loadGMap().then(() => {
      this.overlay.setMap(this.gMap);
      const brazilBounds = {
        west: -73.9868097,
        north: -33.751178,
        east: -28.8476399,
        south: 5.2696195,
      };
      this.gMap?.fitBounds(brazilBounds);
    });
  }

  renderLayers(monitLayer: MVTLayer<monitPoint>) {
    this.overlay.setProps({
      layers: [this.stateLayer, monitLayer],
    });
  }

  async loadGMap() {
    gMapsApiLoader.setOptions({
      key: environment.GOOGLE_API_KEY,
    });
    try {
      const gMapsLib = await gMapsApiLoader.importLibrary('maps');

      const mapEl = document.getElementById(this.gmapElementId)!;
      this.gMap = new gMapsLib.Map(mapEl, {
        gestureHandling: 'cooperative',
        fullscreenControl: false,
        zoomControl: true,
        streetViewControl: false,
        scaleControl: true,
        renderingType: google.maps.RenderingType.RASTER,
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        mapTypeControlOptions: {
          mapTypeIds: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.TERRAIN,
            google.maps.MapTypeId.SATELLITE,
          ],
        },
        clickableIcons: false,
        isFractionalZoomEnabled: true,
        styles: [],
      });
    } catch (error) {
      console.error(error);
    }
  }

  private getOverlay = () =>
    new GoogleMapsOverlay({
      layers: [
        this.stateLayer,
        this.getMonitAreaLayer(this.getMonitAreaURL(this.idList())),
      ],
      widgets: [new LoadingWidget({ placement: 'top-right' })],
      interleaved: false, // se for true,  causa serrilhamento nas geometrias tipo linha
      onClick: async (info) => {},
    });

  overlay = this.getOverlay();
}
